import { gql } from '@apollo/client'

const AUTH_USER_FIELDS = gql`
  fragment AuthUserFields on User {
    id
    email
    firstName
    lastName
    fullName
    phone
    avatarUrl
    locale
    role
    admin
    status
    emailVerified
  }
`

export const SIGN_IN_MUTATION = gql`
  ${AUTH_USER_FIELDS}

  mutation SignIn($email: String!, $password: String!) {
    signIn(input: { email: $email, password: $password }) {
      user {
        ...AuthUserFields
      }
      token
      errors
    }
  }
`

export const SIGN_UP_MUTATION = gql`
  ${AUTH_USER_FIELDS}

  mutation SignUp(
    $email: String!
    $password: String!
    $passwordConfirmation: String!
    $firstName: String!
    $lastName: String!
    $locale: String
  ) {
    signUp(input: {
      email: $email
      password: $password
      passwordConfirmation: $passwordConfirmation
      firstName: $firstName
      lastName: $lastName
      locale: $locale
    }) {
      user {
        ...AuthUserFields
      }
      token
      errors
    }
  }
`

export const PROVIDER_SIGN_UP_MUTATION = gql`
  ${AUTH_USER_FIELDS}

  mutation ProviderSignUp(
    $email: String!
    $password: String!
    $passwordConfirmation: String!
    $firstName: String!
    $lastName: String!
    $phone: String!
    $locale: String
  ) {
    providerSignUp(input: {
      email: $email
      password: $password
      passwordConfirmation: $passwordConfirmation
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      locale: $locale
    }) {
      user {
        ...AuthUserFields
      }
      token
      errors
    }
  }
`

export const REQUEST_PASSWORD_RESET_MUTATION = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(input: { email: $email }) {
      message
      errors
    }
  }
`

export const RESET_PASSWORD_MUTATION = gql`
  ${AUTH_USER_FIELDS}

  mutation ResetPassword(
    $resetPasswordToken: String!
    $password: String!
    $passwordConfirmation: String!
  ) {
    resetPassword(input: {
      resetPasswordToken: $resetPasswordToken
      password: $password
      passwordConfirmation: $passwordConfirmation
    }) {
      user {
        ...AuthUserFields
      }
      token
      errors
    }
  }
`

export const UPDATE_PROFILE_MUTATION = gql`
  ${AUTH_USER_FIELDS}

  mutation UpdateSettingsProfile(
    $firstName: String
    $lastName: String
    $phone: String
    $avatarUrl: String
    $locale: String
  ) {
    updateProfile(input: {
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      avatarUrl: $avatarUrl
      locale: $locale
    }) {
      user {
        ...AuthUserFields
      }
      errors
    }
  }
`

export const UPDATE_PASSWORD_MUTATION = gql`
  ${AUTH_USER_FIELDS}

  mutation UpdateSettingsPassword(
    $currentPassword: String!
    $password: String!
    $passwordConfirmation: String!
  ) {
    updatePassword(input: {
      currentPassword: $currentPassword
      password: $password
      passwordConfirmation: $passwordConfirmation
    }) {
      user {
        ...AuthUserFields
      }
      errors
    }
  }
`
